module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-image"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('div', {
    staticClass: "animation-container"
  }, [_c('img', {
    staticClass: "image-intro",
    attrs: {
      "src": _vm.episode.introImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.playClick()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "intro-text-container"
  }, [_c('div', {
    staticClass: "intro-text-box"
  }, [_c('div', {
    staticClass: "introtext title-02",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.introImageText)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6303d1c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/IntroImage.vue
// module id = 119
// module chunks = 1